import styled from 'styled-components';
import { Clickable } from '../performance-operations/styles';

// PM analitik P5 — E09 yerleşimi: ortak pano ızgarası (performance-operations/styles) + matris/ısı tablosu hücreleri.
// Renkler yalnız tema token'ı; yoğunluk tonu color-mix ile token rengin yüzdesi (kart içinde kaydırma yok).

export const SelectorRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 16px;
`;

export const SelectorField = styled.div`
  width: 280px;
  max-width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Hint = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
  margin-top: 8px;
`;

export const Matrix = styled.div`
  display: grid;
  grid-template-columns: 24px repeat(${({ $cols }) => $cols}, minmax(0, 1fr));
  gap: 6px;
  align-items: stretch;
`;

export const AxisY = styled.div`
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const AxisX = styled.div`
  text-align: center;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const Cell = styled(Clickable)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 84px;
  padding: 10px;
  border-radius: 8px;
  box-sizing: border-box;
  border: 2px solid ${({ theme, $selected }) => ($selected ? theme.colors.primary.main : theme.colors.surface.border)};
  background: ${({ theme, $tone }) => `color-mix(in srgb, ${theme.colors.primary.main} ${Math.round(($tone || 0) * 35)}%, ${theme.colors.surface.card})`};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  min-width: 0;
`;

export const CellName = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CellValue = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.lg};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const HeatTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 3px;
  table-layout: fixed;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.primary};

  th {
    font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
    color: ${({ theme }) => theme.colors.text.muted};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 4px 2px;
    text-align: center;
  }
  th[scope='row'] { text-align: left; }
  td { padding: 0; }
`;

export const HeatCell = styled(Clickable)`
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 2px;
  text-align: center;
  border-radius: 6px;
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  outline: ${({ theme, $diagonal }) => ($diagonal ? `1px dashed ${theme.colors.text.muted}` : 'none')};
  background: ${({ theme, $tone }) => `color-mix(in srgb, ${theme.colors.secondary.main} ${Math.round(($tone || 0) * 45)}%, ${theme.colors.bgColor})`};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const StatList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const StatRow = styled(Clickable)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: ${({ theme, $selected }) => ($selected ? theme.colors.bgColor : 'transparent')};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

export const ListWrap = styled.div`
  grid-column: span 12;
  min-width: 0;
`;
